// import { LogLevel } from '@azure/msal-browser';
import { isFirefox, isIE, isEdge } from 'react-device-detect';
/**  
 * Browser check variables
 * If you support IE, our recommendation is that you sign-in using Redirect APIs
 * If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
 */


// const loggerOptions = {
//   loggerCallback: (level, message, containsPii) => {
//     if (containsPii) {
//       return;
//     }
//     switch (level) {
//       case LogLevel.Error:
//         console.error(message);
//         return;
//       case LogLevel.Info:
//         console.info(message);
//         return;
//       case LogLevel.Verbose:
//         console.debug(message);
//         return;
//       case LogLevel.Warning:
//         console.warn(message);
//         return;
//       default:
//         return;
//     }
//   },
// };


// integratedliving
export const IntLivConfig = {
  auth: {
    clientId: process.env.REACT_APP_IntLivClientID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_IntlivTenantID}/`,
    redirectUri: `/intliv/redirect`, //${process.env.REACT_APP_azure_host} 
    postLogoutRedirectUri: `/`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation : 'localStorage',
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
  },
  // system: {
  //   loggerOptions,
  // },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ['User.Read'],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft-ppe.com/v1.0/me',
};
